<template>
  <div id="fttcross">
    <!-- In lounge component -->

    <!-- {{crosssell_data_passed.data[0].sub_venue_id}} -->

    <div class="loading-results" v-if="!dataloaded">
      <span
        ><i class="fas fa-circle-notch fa-spin"></i>&nbsp;
        {{ getrans("Loading Express Lane Options") }}...</span
      >
    </div>

    <div class="loading-results" v-if="noSlotsAvailable">
      {{ getrans("Sorry, Express Lane not available for the moment.") }}

      <SearchWidget
        :brand_slug="setbrandid"
        brand_theme="light"
        :custom_class="`large-strings no-background no-shadow`"
        showTabs="fasttrack"
        activeTab="fasttrack"
        hideTabs="true"
        :dateStart="date1_forwidget"
        dateEnd=""
        :lang="lang.toLowerCase()"
        :venue_select="String(venue_select)"
        emit_search="true"
        :adults_select="adults_select"
        :children_select="children_select"
        :infants_select="infants_select"
        :senior_select="senior_select"
        :loading_data="loading_data_widget ? 'true' : 'false'"
        :hide_venue_select="`true`"
        :button-text="`Update`"
        :key="refresh_widget"
      />
    </div>

    <div class="results-fade" :class="dataloaded ? '' : 'not-loaded'">
      <div
        class="results"
        v-if="dataloaded && products.length"
        v-show="!disable_add_to_basket"
      >
        <!-- ignore this loop for now it is for different types of fasttrack -->

        <!-- {{finalloungeresults}} -->

        <!-- {{ adults_select }}
      {{ children_select }}
      {{ infants_select }}
      {{ senior_select }} -->

        <template v-for="(items, i) in products" :key="i">
          <div class="results_box">
            <!-- doesnt expand area -->
            <!-- {{product_descriptions[items.product_id]}} -->

            <div class="results_top">
              <div class="results_top_image_title_description">
                <img
                  :src="product_descriptions[items.product_id]['product_image']"
                  class="results_top_image"
                />
                <div class="results_top_title_description">
                  <div class="results_top_title">
                    <span
                      ><b>{{
                        getrans(
                          product_descriptions[items.product_id][
                            "product_title"
                          ]
                        )
                      }}</b></span
                    >
                  </div>
                  <div class="results_top_description">
                    <p>
                      {{
                        getrans(
                          product_descriptions[items.product_id][
                            "product_description"
                          ]
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="results_top_price_button">
                <div class="results_top_price">
                  <template v-for="(cust, k) in customers[i]" :key="k">
                    <div
                      v-if="cust.ctype === 'ADL'"
                      :data-cust="cust.ctype"
                      :data-price="parseFloat(items.ADL_rate || 0).toFixed(2)"
                    >
                      <span>{{ getrans("From") }} &nbsp;</span>
                      <b>
                        {{ currency }}
                        {{ getDisplayPrice(cust, items) }}
                      </b>
                    </div>
                  </template>
                </div>
                <div class="results_top_button">
                  <button
                    @click="
                      !expanding ? (expanded[i] = !expanded[i]) : false;
                      expanding = true;
                    "
                  >
                    <span v-if="!expanded[i]">{{ getrans("View") }}</span>
                    <span v-else
                      ><i class="fa fa-times" aria-hidden="true"></i>
                      {{ getrans("Close") }}</span
                    >
                  </button>
                </div>
              </div>
            </div>

            <div class="datetime-message" v-if="setbrandid === 'HER'">
              <b>
                <i class="fa fa-info-circle"></i> Please use the view button to
                check the date / time of the express lane and the edit button to
                change the date/time if required.
              </b>
            </div>

            <!-- expansion area -->
            <slide-up-down
              v-model="expanded[i]"
              @close-end="expanding = false"
              @open-end="expanding = false"
              :duration="200"
              :responsive="true"
            >
              <div class="date_search">
                <b
                  >{{ getrans("You Searched for:") }}
                  <span class="search-dates">{{
                    set_results_subheadline(
                      items.ftt_suggested_date1_date,
                      items.ftt_suggested_date1_time,
                      items.ADL,
                      items.CHD ? items.CHD : 0,
                      items.INF ? items.INF : 0
                    )
                  }}</span></b
                >
                <button
                  class="edit-search"
                  @click="
                    product_id_selected = items.product_id;
                    expanded_widget[i] = !expanded_widget[i];
                    expanded_results[i] = !expanded_widget[i];
                  "
                >
                  Edit <i class="fas fa-edit"></i>
                </button>
              </div>

              <div v-show="expanded_widget[i]">
                <SearchWidget
                  :lane_select="String(items.lane_item)"
                  :crossell_lane_select="String(items.lane_item)"
                  :brand_slug="setbrandid"
                  brand_theme="light"
                  :custom_class="`large-strings no-background no-shadow no-lane-select`"
                  showTabs="fasttrack"
                  activeTab="fasttrack"
                  hideTabs="true"
                  :dateStart="items.ftt_suggested_date1_forwidget"
                  dateEnd=""
                  :lang="lang.toLowerCase()"
                  :venue_select="String(venue_select)"
                  emit_search="true"
                  :adults_select="items.ADL"
                  :children_select="items.CHD ? items.CHD : children_select"
                  :infants_select="items.INF ? items.INF : infants_select"
                  :senior_select="senior_select"
                  :loading_data="loading_data_widget ? 'true' : 'false'"
                  :hide_venue_select="`true`"
                  :button-text="`Update`"
                />
              </div>

              <div v-show="expanded_results[i]">
                <div class="results_expanded" :ref="`items-${i}`">
                  <!-- loop over the products here -->
                   <!-- {{customers}} -->
                  <template v-for="(cust, j) in customers[i]" :key="j">
                    <div
                      class="results_expanded_wrapper"
                      v-if="from_params(cust.ctype) >= 0"
                    >
                      <div class="results_expanded_title_description">
                        <div class="results_expanded_title">
                          <span>
                            <b>
                              <template v-if="cust.ctype === 'ADL'">
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "title_adult"
                                    ]
                                  )
                                }}
                              </template>
                              <template v-if="cust.ctype === 'CHD'">
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "title_child"
                                    ]
                                  )
                                }}
                              </template>
                              <template v-if="cust.ctype === 'INF'">
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "title_infant"
                                    ]
                                  )
                                }}
                              </template>
                            </b>
                          </span>
                        </div>
                        <div class="results_expanded_description">
                          <!-- <p>
                            The reservation may be changed /cancelled 4 hours
                            before the indicated in reservation Available at
                            terminal 1 and 2.
                          </p> -->
                          <!-- 
                          ADL
                          CHD
                          INF 
                          -->
                          <template v-if="cust.ctype === 'ADL'">
                            <ul>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_1_adult'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_1_adult"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_2_adult'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_2_adult"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_3_adult'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_3_adult"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_4_adult'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_4_adult"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_5_adult'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_5_adult"
                                    ]
                                  )
                                }}
                              </li>
                            </ul>
                          </template>
                          <template v-if="cust.ctype === 'CHD'">
                            <ul>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_1_child'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_1_child"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_2_child'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_2_child"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_3_child'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_3_child"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_4_child'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_4_child"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_5_child'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_5_child"
                                    ]
                                  )
                                }}
                              </li>
                            </ul>
                          </template>
                          <template v-if="cust.ctype === 'INF'">
                            <ul>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_1_infant'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_1_infant"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_2_infant'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_2_infant"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_3_infant'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_3_infant"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_4_infant'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_4_infant"
                                    ]
                                  )
                                }}
                              </li>
                              <li
                                v-if="
                                  product_descriptions[items.product_id][
                                    'description_5_infant'
                                  ]
                                "
                              >
                                {{
                                  getrans(
                                    product_descriptions[items.product_id][
                                      "description_5_infant"
                                    ]
                                  )
                                }}
                              </li>
                            </ul>
                          </template>
                        </div>
                      </div>
                      <div class="results_expanded_price_quantity">
                        <div class="results_expanded_price">
                          <!-- <span>
                            {{ getrans(cust.display) }}&nbsp;{{
                              getrans("Tickets")
                            }}:&nbsp;&nbsp;</span
                          > -->
                          <span
                            v-if="
                              (cust.ctype === 'ADL' && items.ADL_rate) ||
                              (cust.ctype === 'CHD' && items.CHD_rate) ||
                              (cust.ctype === 'INF' && items.INF_rate)
                            "
                          >
                            <!-- <span style="display: none">{{
                              cust.ctype === "ADL"
                                ? (cust.from_display_price = parseFloat(
                                    packages_products[
                                      bdataa[items.ma].packages[
                                        items.product_id
                                      ]
                                    ].pricing[cust.ctype].rate
                                  ).toFixed(2))
                                : ""
                            }}</span> -->
                            <b
                              :data-cust="cust.ctype"
                              :data-price="
                                parseFloat(
                                  cust.ctype === 'ADL' ? items.ADL_rate :
                                  cust.ctype === 'CHD' ? items.CHD_rate :
                                  cust.ctype === 'INF' ? items.INF_rate : 0
                                ).toFixed(2)
                              "
                              >{{ currency }}
                              {{
                                parseFloat(
                                  cust.ctype === 'ADL' ? items.ADL_rate :
                                  cust.ctype === 'CHD' ? items.CHD_rate :
                                  cust.ctype === 'INF' ? items.INF_rate : 0
                                ).toFixed(2)
                              }}</b
                            ></span
                          >
                        </div>
                        <div class="results_expanded_quantity">
                          <div class="quantity-selector">
                            <select
                              v-if="cust.ctype === 'ADL'"
                              name="quantity"
                              :ref="`quantity-${i}-${j}`"
                              :id="`quantity-${i}-${j}`"
                              v-model.number="cust.count"
                              @change="
                                set_sub_total(
                                  `items-${i}`,
                                  `subtotal-${i}`,
                                  cust.ctype
                                )
                              "
                            >
                              <option v-if="cust.ctype != 'ADL'" value="0">
                                0
                              </option>
                              <template
                                v-for="opt in cust.drop_count"
                                :key="opt"
                              >
                                <option :value="opt">{{ opt }}</option>
                              </template>
                            </select>

                            <select
                              v-if="cust.ctype === 'CHD'"
                              name="quantity"
                              :ref="`quantity-${i}-${j}`"
                              :id="`quantity-${i}-${j}`"
                              v-model.number="cust.count"
                              @change="
                                set_sub_total(
                                  `items-${i}`,
                                  `subtotal-${i}`,
                                  cust.ctype
                                )
                              "
                            >
                              <option v-if="cust.ctype != 'ADL'" value="0">
                                0
                              </option>
                              <template
                                v-for="opt in cust.drop_count"
                                :key="opt"
                              >
                                <option :value="opt">{{ opt }}</option>
                              </template>
                            </select>

                            <select
                              v-if="cust.ctype === 'INF'"
                              name="quantity"
                              :ref="`quantity-${i}-${j}`"
                              :id="`quantity-${i}-${j}`"
                              v-model.number="cust.count"
                              @change="
                                set_sub_total(
                                  `items-${i}`,
                                  `subtotal-${i}`,
                                  cust.ctype
                                )
                              "
                            >
                              <option v-if="cust.ctype != 'ADL'" value="0">
                                0
                              </option>
                              <template
                                v-for="opt in cust.drop_count"
                                :key="opt"
                              >
                                <option :value="opt">{{ opt }}</option>
                              </template>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- subtotal to add to basket -->
                  <div class="results_add" :ref="`subtotal-section-${i}`">
                    <div
                      class="results_add_subtotal"
                      :class="check_zero_subtotal(i)"
                    >
                      <!-- needs to be calculated and update as quantity is changed 
                      and set back to 0 when add to basket clicked -->
                      <span>{{ getrans("Subtotal") }}:</span>&nbsp;&nbsp;<span
                        ><b
                          >{{ currency }}
                          <span>{{ fasttracksubtotal_array[i] }}</span>
                          <span style="display: none" :ref="`subtotal-${i}`"
                            >0.00</span
                          >
                        </b></span
                      >
                    </div>
                    <div class="results_add_button">
                      <button
                        @click="
                          addtobasket(
                            items.id,
                            items.duration,
                            items.product_name,
                            items.ftt_suggested_date1_date,
                            items.ftt_suggested_date1_time,
                            items.product_id,
                            i
                          )
                        "
                        :ref="`disabled-${i}`"
                      >
                        <i
                          v-if="add_to_basket_loader"
                          class="fas fa-circle-notch fa-spin"
                        ></i>
                        {{ getrans("Add to basket") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </slide-up-down>
          </div>
        </template>
      </div>
    </div>

    <!-- <pre>
       {{ crosssell_data }} 
    </pre> -->
  </div>
</template>

<script>
import apiProxy from "@/services/apiProxy.js";

var crypto = require("crypto");
const { v4: uuidv4 } = require("uuid");
import { useToast } from "vue-toastification";
const toast = useToast();

import SearchWidget from "../components/SearchWidgetCustomElement.vue";
import { getBrandConfig } from "@/brand/brand.config.js";
//import SlideShow from "../components/SlideShow.vue";

/* eslint-disable */
import en from "date-format-parse/lib/locale/en";
import el from "date-format-parse/lib/locale/el";
import de from "date-format-parse/lib/locale/de";
import fr from "date-format-parse/lib/locale/fr";
import es from "date-format-parse/lib/locale/es";
import pt from "date-format-parse/lib/locale/pt";
/* eslint-enable */

import md5 from "js-md5";

import { loadTranslations as loadTranslationsModule } from "@/modules/loadTranslations";

const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

export default {
  name: "CrossSellResultsFTT",
  props: {
    crosssell_data_passed: undefined,
    num_of_crosssells: undefined,
  },
  components: {
    SearchWidget,
    //SlideShow,
  },
  data() {
    return {
      crosssell_data: "",
      refresh_widget: 0,
      update_lounge: 0,
      cross_sell_lounge_suggested: [],
      cross_sell_ftt_outbound: [],
      cross_sell_ftt_inbound: [],
      final_amount: 0,
      package_id_selected: "",
      product_id_selected: "",
      buttonisActive: false,
      loading_data_widget: false,
      styles_loaded: false,
      currency: "",
      partner_id: "",
      partner_name: "",
      campaign_id: "",
      campaign_name: "",
      search_origin: "",
      product_descriptions: {},
      expanding: false,
      expanded: [],
      expanded_widget: [],
      expanded_results: [true, true, true, true, true, true],
      visitortypes: [],
      lang: "en",
      translations: "",
      discount_value: 0,
      discount_type: "",
      brandSlug: "",
      date1_forwidget: "",
      date2_forwidget: "",
      date1_date: "2023/01/24",
      date1_time: "14:30",
      date2_date: "",
      date2_time: "",
      searchres: [],
      venue_select: "",
      venue_select_name: "",
      lane_id: "",
      lane_select: "",
      adults_select: "1",
      children_select: "0",
      infants_select: "0",
      senior_select: "",
      carparkdetails: [],
      dataloaded: false,
      products: [],
      viewItemListSent: false,
      fasttracksubtotal: 0,
      actcustomers: [],
      actcustomerprices: [],
      minpricepackage: [],
      mc_item: [],
      customers: [],
      venue: {},
      bdataa: [],
      packages_products: [],
      dataloaded_carparkdetails: false,
      widgetloaded: false,
      css_data: undefined,
      results_headline: "",
      results_subheadline: "",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: false,
      result_selected_style: "list",
      result_selected_order: "closest",
      showSearchWidget: false,
      noSlotsAvailable: false,
      neworder: false,
      neworder_key: 0,
      closeest_cheapest: "closest",
      searchres_filtered: {},
      disable_add_to_basket: false,
      setbrandid: "",
      add_to_basket_loader: false,
      brandloaded: false,
      manual_search: false,
      suggestions_data: [],
      lane_id_selected: "",
      suggestion_sub_product_id: [],
      fasttracksubtotal_array: [],
      booking_max_pax: 10,
    };
  },
  methods: {
    getDisplayPrice(cust, items) {
      if (cust.ctype === "ADL") {
        const price = parseFloat(items.ADL_rate || 0).toFixed(2);
        cust.from_display_price = price;
        return price;
      }
      return "";
    },
    gensessionid() {
      if (encryptStorage.getItem("search_analytics_id") === undefined) {
        let search_analytics_id = crypto.randomBytes(16).toString("base64");
        encryptStorage.setItem("search_analytics_id", search_analytics_id);
        return search_analytics_id;
      } else {
        return encryptStorage.getItem("search_analytics_id");
      }
    },
    check_zero_subtotal(i) {
      let results_add = this.$refs[`subtotal-section-${i}`];
      let subtotal_el = this.$refs[`subtotal-${i}`];
      console.info(subtotal_el);
      if (results_add && subtotal_el) {
        if (subtotal_el.innerHTML === "0.00") {
          this.disable_add_to_basket = false;
          //results_add.style.display = "none";
        } else {
          this.disable_add_to_basket = false;
          //results_add.style.display = "flex";
        }
      }
    },

    validate_data(i, s, ctype) {
      console.info("i", i);
      console.info("s", s);
      console.info("ctype", ctype);
      var adl = 0;
      var chi = 0;
      var inf = 0;
      for (let key in this.actcustomers) {
        let q = Number(this.actcustomers[key]);
        if (key == "ADL") {
          adl = q;
        }
        if (key == "CHD") {
          chi = q;
        }
        if (key == "INF") {
          inf = q;
        }
      }

      for (var y = 0; y < this.customers.length; y++) {
        if (this.customers[y].ctype == "ADL") {
          if (Number(adl) + Number(chi) + Number(inf) > this.booking_max_pax) {
            adl = this.booking_max_pax - (Number(chi) + Number(inf));
          }
          let adult_count = this.booking_max_pax - (Number(chi) + Number(inf));
          this.customers[y].count = adl;
          this.customers[y].drop_count = adult_count;
        }
        if (this.customers[y].ctype == "CHD") {
          if (Number(adl) + Number(chi) + Number(inf) > this.booking_max_pax) {
            chi = this.booking_max_pax - (Number(adl) + Number(inf));
          }
          let adult_count = this.booking_max_pax - (Number(adl) + Number(inf));
          this.customers[y].count = chi;
          this.customers[y].drop_count = adult_count;
        }
        if (this.customers[y].ctype == "INF") {
          if (Number(adl) + Number(chi) + Number(inf) > this.booking_max_pax) {
            inf = this.booking_max_pax - (Number(chi) + Number(adl));
          }
          let adult_count = this.booking_max_pax - (Number(chi) + Number(adl));
          this.customers[y].count = inf;
          this.customers[y].drop_count = adult_count;
        }
      }
    },

    from_params(ctype) {
      switch (ctype) {
        case "ADL":
          return this.adults_select;
        case "CHD":
          return this.children_select;
        case "INF":
          return this.infants_select;
        default:
          return 0;
      }
    },
    acival(ctype) {
      if (ctype == "ADL") {
        return 1;
      } else {
        return 0;
      }
    },
    getCrossSellSelectionState(itemRef) {
      const refTarget = this.$refs[itemRef];
      const container = Array.isArray(refTarget) ? refTarget[0] : refTarget;
      const selectionState = {
        quantities: {},
        prices: {},
        subtotal: 0,
      };

      if (!container) {
        return selectionState;
      }

      const priceAndQuantity = [
        ...container.querySelectorAll(".results_expanded_price_quantity"),
      ];

      priceAndQuantity.forEach((el) => {
        const priceNode = el.querySelector("[data-price]");
        const customerNode = el.querySelector("[data-cust]");
        const selectNode = el.querySelector("select");

        if (!priceNode || !customerNode || !selectNode) {
          return;
        }

        const customerType = customerNode.getAttribute("data-cust");
        const price = Number(
          parseFloat(priceNode.getAttribute("data-price") || 0).toFixed(2)
        );
        const quantity = Number(selectNode.value || 0);

        selectionState.quantities[customerType] = quantity;
        selectionState.prices[customerType] = price;
        selectionState.subtotal += price * quantity;
      });

      selectionState.subtotal = Number(selectionState.subtotal.toFixed(2));

      return selectionState;
    },
    async addtobasket(
      id,
      duration,
      product_name,
      date1_date,
      date1_time,
      product_id,
      index
    ) {
      this.add_to_basket_loader = true;
      const selectionState = this.getCrossSellSelectionState(`items-${index}`);
      Object.keys(selectionState.quantities).forEach((key) => {
        this.actcustomers[key] = selectionState.quantities[key];
      });
      Object.keys(selectionState.prices).forEach((key) => {
        this.actcustomerprices[key] = selectionState.prices[key];
      });
      if (selectionState.subtotal > 0) {
        this.fasttracksubtotal_array[index] = selectionState.subtotal;
      }
      console.info("id", id);
      console.info("id", duration);
      console.info("actcustomers", this.actcustomers);
      console.info("actcustomerprices", this.actcustomerprices);
      console.info("date1_date", this.date1_date);
      console.info("date1_time", this.date1_time);
      let guid = this.genuuid();
      let fincust = this.actcustomers;
      console.info("fincust", fincust);
      let fincustprices = this.actcustomerprices;
      console.info("guid", guid);
      console.info("fincust", fincust);
      console.info("fincustprices", fincustprices);
      this.setLocalData("venue_selected_ftt", this.venue_select);
      this.setLocalData("venue_selected_name_ftt", this.venue_select_name);
      this.setLocalData("lane_id_ftt", this.lane_id_selected);
      let dispdate = date1_date.split("/");
      let date_selected_display =
        dispdate[2] + "/" + dispdate[1] + "/" + dispdate[0];
      let ftt_order_ref = "";
      let orefwithoutprefix = encryptStorage.getItem("orefwithoutprefix");
      if (typeof orefwithoutprefix !== "undefined") {
        orefwithoutprefix = encryptStorage.getItem("orefwithoutprefix");
      } else {
        orefwithoutprefix = new Date().getTime();
        encryptStorage.setItem("orefwithoutprefix", orefwithoutprefix);
      }
      ftt_order_ref = this.setbrandid + "-FTT-" + orefwithoutprefix;
      encryptStorage.setItem("ftt_order_ref", ftt_order_ref);

      let fasttrack = {
        id: id,
        product_id: product_id,
        duration: duration,
        ADL: fincust.ADL,
        CHD: fincust.CHD,
        INF: fincust.INF,
        ADL_PR: fincustprices.ADL,
        CHD_PR: fincustprices.CHD,
        INF_PR: fincustprices.INF,
        guid: guid,
        date_selected: date1_date,
        date_selected_display: date_selected_display,
        time_selected: date1_time,
        fasttracksubtotal: this.fasttracksubtotal_array[index],
        product_name: product_name,
        venue_select_name: this.venue_select_name,
        venue_id: this.venue_select,
        ftt_order_ref: ftt_order_ref,
        orefwithoutprefix: orefwithoutprefix,
        crossell: "Yes",
        source: "crosssellftt",
      };
      let fttcart = encryptStorage.getItem("fasttrack_cart") || [];
      if (fttcart.length > 0) {
        let resetfttcart = [];
        for (let d = 0; d < fttcart.length; d++) {
          let it_cart = fttcart[d];
          if (it_cart.product_id != product_id) {
            resetfttcart.push(it_cart);
          }
        }
        fttcart = resetfttcart;
      }
      fttcart.push(fasttrack);
      
      let it = {};
      it.duration = duration;
      it.id = id;
      let nounits = 0;
      let adl = 0;
      let chn = 0;
      let ifl = 0;
      let coachar = [];
      for (let key in this.actcustomers) {
        var q = 0;
        q = Number(this.actcustomers[key]);
        nounits = nounits + q;
        if (key == "ADL") {
          adl = q;
        }
        if (key == "CHD") {
          chn = q;
        }
        if (key == "INF") {
          ifl = q;
        }
      }
      it.no_of_units = nounits;
      it.unit_data = { ADL: adl, CHD: chn, INF: ifl };
      coachar.push(it);
      let datacart = {};
      datacart = {
        brand_id: this.setbrandid,
        guid: guid,
        entry_date: date1_date,
        book_data: coachar,
      };
      console.info("datacart", datacart);

      const response = await apiProxy.call("fasttrack_reserve", datacart);
      console.info('fasttrack_reserve',response.status);
      if (response && response.status == "success") {
      encryptStorage.setItem("fasttrack_cart", fttcart);
      console.info("fasttrack_cart", encryptStorage.getItem("fasttrack_cart"));        
        encryptStorage.setItem("crosssell_in_cart", "Yes");

          const variantMap = {
            ADL: "Adult",
            CHD: "Child",
            INF: "Infant",
          };
          const itemEntryDate = this.formatDateymd_dashed(this.date1_date);
          const itemEntryTime = this.date1_time;
          const itemListId =
            this.setbrandid.toLowerCase() + "_fasttrack_crosssell";
          const itemListName =
            this.setbrandid.toUpperCase() + " Fasttrack Crosssell";
          const currentFttItems = Object.keys(variantMap)
            .map((key) => {
              const quantity = Number(fincust[key] || 0);
              const price = Number(
                parseFloat(fincustprices[key] || 0).toFixed(2)
              );
              if (!quantity || !Number.isFinite(price) || price <= 0) {
                return null;
              }
              return {
                item_id: String(product_id),
                item_name: product_name,
                item_category: "Fasttrack - Cross Sell - Add On",
                item_variant: variantMap[key],
                price,
                quantity,
                item_entry_date: itemEntryDate,
                item_entry_time: itemEntryTime,
                item_list_id: itemListId,
                item_list_name: itemListName,
                venue: this.venue_select_name,
              };
            })
            .filter(Boolean);

          const currentFttValue = currentFttItems.reduce(
            (sum, item) => sum + Number(item.price) * Number(item.quantity),
            0
          );

          const addToCartPayload = {
            event: "add_to_cart",
            ecommerce: {
              currency: "GBP",
              value: Number(currentFttValue.toFixed(2)),
              items: currentFttItems,
            },
          };

          let datalayerparams = encryptStorage.getItem("datalayerparams") || {};
          if (typeof datalayerparams !== "object" || datalayerparams === null) {
            datalayerparams = {};
          }

          let fttItems = [];
          if (
            datalayerparams.ftt &&
            datalayerparams.ftt.ecommerce &&
            Array.isArray(datalayerparams.ftt.ecommerce.items)
          ) {
            fttItems = datalayerparams.ftt.ecommerce.items.filter(
              (it) => String(it.item_id) !== String(product_id)
            );
          }
          fttItems = fttItems.concat(currentFttItems);

          const fttTotal = fttItems.reduce(
            (sum, it) =>
              sum +
              Number(parseFloat(it.price || 0).toFixed(2)) *
                Number(it.quantity || 0),
            0
          );

          datalayerparams.ftt = {
            event: "add_to_cart",
            ecommerce: {
              currency: "GBP",
              value: Number(fttTotal.toFixed(2)),
              items: fttItems,
            },
          };
          encryptStorage.setItem("datalayerparams", datalayerparams);

          if (this.setbrandid === "AIR" || this.setbrandid === "BHX") {
            /* eslint-disable */
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push(addToCartPayload);
            /* eslint-enable */
          }

        let update_basket = new CustomEvent("update_basket", {
          detail: {
            basket: "update",
          },
        });
        window.dispatchEvent(update_basket);
        toast(`${product_name} ${this.getrans("added to basket")}`);
          // }
        setTimeout(() => {
          this.add_to_basket_loader = false;
        }, 1000);
      } else {
        console.error("There was an error adding to basket");
         toast(`${response.errors}`);
        console.error(response);
        this.add_to_basket_loader = false;
      }
    },
    set_sub_total(item, subtotal_el, custtype) {
      console.info("subtotal_el_item_aa", item);
      console.info("subtotal_cust.ctype", custtype);
      console.info("actcustomers", this.actcustomers);

      if (this.$refs[item] && this.$refs[subtotal_el]) {
        console.info("subtotal_el_aa", subtotal_el);
        let price_and_quantity = [
          ...this.$refs[item].querySelectorAll(
            ".results_expanded_price_quantity"
          ),
        ];
        let subtotal = [];
        price_and_quantity.map((el) => {
          let price = el
            .querySelector("[data-price]")
            .getAttribute("data-price");
          let cust = el.querySelector("[data-cust]").getAttribute("data-cust");
          let quantity = el.querySelector("select").value;
          subtotal.push({ price, quantity, cust });
        });
        let subtotal_display = "0.00";
        subtotal.map((val) => {
          console.info("vall", val);
          this.actcustomers[val.cust] = val.quantity;
          this.actcustomerprices[val.cust] = val.price;
          subtotal_display =
            Number(
              Number(subtotal_display) +
                Number(val.price) * Number(val.quantity)
            ).toFixed(2) + "";
        });

        for (let i = 0; i < this.cross_sell_lounge_suggested.length; i++) {
          let stotal_el = "subtotal-" + i;
          this.$refs[stotal_el].innerHTML = subtotal_display;
        }

        this.fasttracksubtotal = subtotal_display;
        this.fasttracksubtotal_array[item.split("-")[1]] =
          this.fasttracksubtotal;

        let disabled_el = subtotal_el.replace("subtotal-", "disabled-");

        if (subtotal_display === "0.00") {
          this.$refs[disabled_el].disabled = true;
        } else {
          this.$refs[disabled_el].disabled = false;
        }
      }
      console.info("actcustomers post", this.actcustomers);
      this.validate_data(item, subtotal_el, custtype);
      this.check_zero_subtotal(item);
    },

    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    async loadTranslations() {
      const translations = await loadTranslationsModule(this.setbrandid);
      this.translations = translations;
      this.lang = sessionStorage.getItem("language") || this.lang || "en";
    },

    put(key, value, obj) {
      obj[key] = value;
      return obj;
    },
    setListStyle(type) {
      this.result_selected_style = type;
    },

    sortByDistancePrice() {
      /* eslint-disable */
      this.searchres_filtered = {};
      for (let j = 0; j < this.searchres.length; j++) {
        for (let i = 0; i < this.neworder.length; i++) {
          if (
            this.searchres[j].carpark_id &&
            this.searchres[j].carpark_id === this.neworder[i]
          ) {
            this.searchres_filtered[i] = this.searchres[j];
          }
        }
      }
      /* eslint-enable */
    },

    setListOrder(type) {
      if (!this.carparkdetails && !this.carparkdetails.clients) {
        return false;
      }
      if (
        this.carparkdetails.clients === "null" ||
        this.carparkdetails.clients === undefined
      ) {
        return null;
      }

      if (type === "closest") {
        this.closeest_cheapest = "closest";
        this.result_selected_order = type;
        let obj = Object.values(this.carparkdetails.clients);
        let neworder = obj.sort(function (a, b) {
          if (b.distance_order) {
            return a.distance_order - b.distance_order;
          }
        });
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].carpark_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
      }

      if (type === "cheapest") {
        this.closeest_cheapest = "cheapest";

        this.result_selected_order = type;
        let obj = Object.values(this.searchres);
        console.info(obj);

        let neworder = obj.sort(function (a, b) {
          if (b.grand_total) {
            return a.grand_total - b.grand_total;
          }
        });
        let newobj = [];
        for (let i = 0; i < neworder.length; i++) {
          newobj.push(neworder[i].carpark_id);
        }
        this.neworder = newobj;
        this.neworder_key++;
      }

      this.sortByDistancePrice();
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;
    },
    genuuid() {
      if (sessionStorage.getItem("uuid") === null) {
        let uuidgen = uuidv4();
        this.setLocalData("uuid", uuidgen);
        return sessionStorage.getItem("uuid");
      } else {
        return sessionStorage.getItem("uuid").replaceAll('"', "");
      }
    },
    async getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        const response = await apiProxy.call("brand_details", {
          brandslug: this.setbrandid,
        });
        if (response && response.code == "1") {
          this.setLocalData("brand_data", response);
          this.setBrandData();
        }
      }
    },

    setMenu(data) {
      if (!Array.isArray(data.brand_menu) || !data.brand_menu.length > 0)
        return;
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    createPanels(data) {
      let panels_data = data.brand_home_panels || [];
      panels_data.sort((a, b) => (a.rownum > b.rownum ? 1 : -1));
      panels_data = panels_data.reduce((a, r) => {
        if (!a[r.rownum]) a[r.rownum] = { row: r.rownum, columns: [] };
        a[r.rownum].columns.push(r);
        return a;
      }, {});
      this.panels_group = panels_data;
    },
    correctdate(d) {
      if (d) {
        d = d.replace("st", "");
        d = d.replace("nd", "");
        d = d.replace("rd", "");
        d = d.replace("th", "");
        return d;
      }
    },
    formatDateymd(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("/");
    },
    formatDateymd_dashed(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    format_date(date, format_date) {
      const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
      if (date) {
        //console.info(date);
        let dt = new Date(date);
        //let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        let month = months[dt.getMonth()];
        let day =
          dt.getDate() +
          (dt.getDate() % 10 == 1 && dt.getDate() != 11
            ? "st"
            : dt.getDate() % 10 == 2 && dt.getDate() != 12
            ? "nd"
            : dt.getDate() % 10 == 3 && dt.getDate() != 13
            ? "rd"
            : "th");

        let hours = dt.getHours();
        let mins = dt.getMinutes();
        let year = dt.getFullYear();
        let dateString = "";
        if (format_date === "date") {
          dateString = `${month} ${day} ${year}`;
        }
        if (format_date === "time") {
          dateString = `${pad(hours)}:${pad(mins)}`;
        }
        return dateString;
      }
    },

    sendFasttrackViewItemListToDataLayer() {
      if (
        this.setbrandid !== "BHX" ||
        !Array.isArray(this.products) ||
        this.viewItemListSent
      ) {
        return;
      }

      const entryDate = this.formatDateymd(this.date1_date)?.replace(/\//g, "-");
      const items = this.products
        .map((product, index) => {
          const packageId =
            this.bdataa?.[product.ma]?.packages?.[product.product_id];
          const adlRate = this.packages_products?.[packageId]?.pricing?.ADL?.rate;
          const fromPrice = Number(
            parseFloat(product.ADL_rate ?? product.price ?? adlRate ?? 0).toFixed(
              2
            )
          );

          return {
            item_id: String(product.product_id || index + 1),
            item_name: product.product_name || "Fasttrack",
            item_category: "Fasttrack",
            price: Number.isFinite(fromPrice) ? fromPrice : 0,
            index: index + 1,
            entry_date: entryDate,
            entry_time: this.date1_time || null,
            venue: this.venue_select_name || "Fasttrack",
          };
        })
        .filter((item) => item.item_id && item.item_name);

      if (!items.length) {
        return;
      }

      const totalValue = Number(
        items.reduce((sum, item) => sum + (Number(item.price) || 0), 0).toFixed(2)
      );

      const payload = {
        event: "view_item_list",
        ecommerce: {
          item_list_id: this.setbrandid.toLowerCase() + "_fasttrack_crosssell",
          item_list_name: this.setbrandid.toUpperCase() + " Fasttrack Crosssell",
          currency: "GBP",
          value: totalValue,
          items,
        },
      };

      try {
        /* eslint-disable */
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push(payload);
        /* eslint-enable */
        this.viewItemListSent = true;
      } catch (e) {
        void e;
      }
    },

    format_date_with_locale(date, format_date) {
      const pad = (n, s = 2) => `${new Array(s).fill(0)}${n}`.slice(-s);
      if (date) {
        let language;
        let digits = 2;
        if (this.lang === "en") {
          language = en;
        }
        if (this.lang === "el") {
          language = el;
        }
        if (this.lang === "de") {
          language = de;
        }
        if (this.lang === "fr") {
          language = fr;
        }
        if (this.lang === "es") {
          language = es;
          digits = 3;
        }
        if (this.lang === "pt") {
          language = pt;
          digits = 3;
        }
        let lang_obj;
        if (digits === 2) {
          lang_obj = {
            formatLocale: language,
            yearFormat: "YYYY",
            monthFormat: "MMM",
            monthBeforeYear: true,
          };
        } else if (digits === 3) {
          lang_obj = {
            formatLocale: language,
            yearFormat: "YYYY",
            monthFormat: "MMM",
            days: language.weekdaysShort,
            monthBeforeYear: true,
          };
        }

        console.info("lang_obj");
        console.info(lang_obj);
        let months = lang_obj.formatLocale.monthsShort;
        if (this.setbrandid === "BHX") {
          months = lang_obj.formatLocale.months;
        }

        let dt = new Date(date);

        let month = months[dt.getMonth()];
        let day = dt.getDate() + "";

        if (this.lang === "en") {
          day =
            dt.getDate() +
            (dt.getDate() % 10 == 1 && dt.getDate() != 11
              ? "st"
              : dt.getDate() % 10 == 2 && dt.getDate() != 12
              ? "nd"
              : dt.getDate() % 10 == 3 && dt.getDate() != 13
              ? "rd"
              : "th");
        }

        let hours = dt.getHours();
        let mins = dt.getMinutes();
        let year = dt.getFullYear();
        let dateString = "";
        if (format_date === "date") {
          dateString = `${month} ${day} ${year}`;
        }
        if (format_date === "time") {
          dateString = `${pad(hours)}:${pad(mins)}`;
        }
        return dateString;
      }
    },

    async getApiData_fasttrack(fttData = null) {
      // if (
      //   !this.adults_select ||
      //   this.adults_select === "0" ||
      //   !this.date1_date
      // ) {
      //   this.noSlotsAvailable = true;
      //   return;
      // }

      let data = {
        brand_id:
          this.setbrandid === "BH1" || this.setbrandid === "BH2"
            ? "BHX"
            : this.setbrandid,
        guid: this.genuuid(),
        entry_date: fttData ? fttData.date : this.date1_date,
        unit_data: {
          adult: Number(2),
          child: Number(0),
          infant: Number(0),
        },
        tracking_id: this.gensessionid(),
        partner_id: this.partner_id,
        partner_name: this.partner_name,
        campaign_id: this.campaign_id,
        campaign_name: this.campaign_name,
        search_origin: this.search_origin,
        venue_name: this.venue_select_name,
        lane_id: fttData ? fttData.lane_id : this.lane_id,
      };
      const response = await apiProxy.call("fasttrack_search", data);

      let datasent = response;

      this.searchres = datasent;

      console.info("this.searchres", this.searchres);

      if (this.searchres === "No Slots Available") {
        this.noSlotsAvailable = true;
      }
      this.products_searchres = this.searchres.products;
      this.venue = this.searchres.venue;
      this.bdataa = this.searchres.data;
      this.packages_products = this.searchres.packages;

      let mch = [];
      let mc = [];
   let d1 = String(fttData && fttData.time ? fttData.time : this.date1_time)
     .trim()
     .toString();
              
                         
            for (let u = 0; u < this.cross_sell_lounge_suggested.length; u++) {
              for (let h = 0; h < this.bdataa.length; h++) {
                let lane_item = this.bdataa[h].lane_id;
                let d = this.bdataa[h].duration;
                let dar = d.split("-");
                let d_start = dar[0].trim().toString(); 
                console.info(
                  "lane_item" +
                    lane_item +
                    "==" +
                    this.cross_sell_lounge_suggested[u]
                );

                if (lane_item == this.cross_sell_lounge_suggested[u] && d_start == d1) {
                  if (!mch.includes(lane_item)) {
                    mch.push(lane_item);
                    let lanes_it = {};
                    lanes_it.lane_item = lane_item;
                    lanes_it.index = h;
                    mc.push(lanes_it);
                  }
                }
              }
            }
            this.mc_item = mc;
            console.info("mch", mc.length);

            console.info("this.mc_item_item", this.mc_item);
            let prod = [];

            for (let h = 0; h < mc.length; h++) {
              let ma = mc[h].index;
              let lane_item = mc[h].lane_item;
              let pro = this.bdataa[ma].packages;

             

              let prokeys = Object.keys(pro);

              for (let l = 0; l < prokeys.length; l++) {
                let it = {};
                it.product_id = parseInt(prokeys[l]);

 console.info("ADL rate",this.packages_products[
                            this.bdataa[ma].packages[parseInt(prokeys[l])]
                          ].pricing["ADL"].rate);

                for (var n = 0; n < this.products_searchres.length; n++) {
                  let pp = parseInt(this.products_searchres[n].product_id);
                  if (pp == parseInt(prokeys[l])) {
                    it.product_name = this.products_searchres[n].product_name;
                    it.ma = ma;
                    for (var u = 0; u < this.suggestions_data.length; u++) {
                      if (
                        lane_item == this.suggestions_data[u].ftt_suggested_id
                      ) {
                        it.lane_item = lane_item;
                        it.ftt_suggested_date1_date =
                          this.suggestions_data[u].ftt_suggested_date1_date;
                        it.ftt_suggested_date1_time =
                          this.suggestions_data[u].ftt_suggested_date1_time;
                        it.ftt_suggested_lane_type =
                          this.suggestions_data[u].ftt_suggested_lane_type;
                        it.ftt_suggested_date1_forwidget =
                          this.suggestions_data[
                            u
                          ].ftt_suggested_date1_forwidget;
                        it.ADL = this.suggestions_data[u].ADL;
                        it.CHD = this.suggestions_data[u].CHD;
                        it.INF = this.suggestions_data[u].INF;

                         it.id = this.bdataa[ma].id;
                        it.duration = this.bdataa[ma].duration;
                        
                        let pricing = this.packages_products[this.bdataa[ma].packages[parseInt(prokeys[l])]].pricing;
                        if(pricing["ADL"]) it.ADL_rate = pricing["ADL"].rate;
                        if(pricing["CHD"]) it.CHD_rate = pricing["CHD"].rate;
                        if(pricing["INF"]) it.INF_rate = pricing["INF"].rate;
                      }
                    }
                    prod.push(it);
                  }
                }
                
              }
            }
             //this.products = prod;
            
            if(this.products.length > 0 && prod.length > 0) {
              this.products.push(...prod);
            } else {
              this.products = prod;
            }
            console.info('this.products_fasttrack',this.products)

      await this.getDescriptions();
    },

    async getDescriptions() {
      let data = {
        brand_id: this.setbrandid,
      };

      const response = await apiProxy.call("vq_details", data);
      if (response && response.clients) {
        this.dataloaded = true;
        setTimeout(() => {
          this.set_results_quantitys();
        }, 0);
        this.product_descriptions = response.clients;
        setTimeout(() => {
          if (this.manual_search) {
            this.expanded[0] = true;
          }
          this.loading_data_widget = false;
          this.set_fttcrossell_shown();
          this.expanded_widget[0] = false;
          this.expanded_results[0] = true;
          for (
            let index = 0;
            index < this.cross_sell_lounge_suggested.length;
            index++
          ) {
            this.$emit("loading_results_finished", "true");
          }
        }, 500);
      }
    },

    set_results_subheadline(
      date1_date,
      date1_time
    ) {

      let results_subheadline =
        this.format_date_with_locale(date1_date, "date") +
        " " +
        this.getrans("at") +
        " " +
        this.format_date_with_locale(date1_date + " " + date1_time, "time");
      if (this.adults_select) {
        let adult_string = "";
        if (Number(this.adults_select) > 1) {
          adult_string = this.getrans("Adults");
          results_subheadline += ", " + this.adults_select + " " + adult_string;
        } else if (Number(this.adults_select) === 1) {
          adult_string = this.getrans("Adult");
          results_subheadline += ", " + this.adults_select + " " + adult_string;
        }
      }
      if (this.children_select) {
        let children_string = "";
        if (Number(this.children_select) > 1) {
          children_string = this.getrans("Children");
          results_subheadline +=
            ", " + this.children_select + " " + children_string;
        } else if (Number(this.children_select) === 1) {
          children_string = this.getrans("Child");
          results_subheadline +=
            ", " + this.children_select + " " + children_string;
        }
      }
      if (this.infants_select) {
        let infants_string = "";
        if (Number(this.infants_select) > 1) {
          infants_string = this.getrans("Infants");
          results_subheadline +=
            ", " + this.infants_select + " " + infants_string;
        } else if (Number(this.infants_select) === 1) {
          infants_string = this.getrans("Infant");
          results_subheadline +=
            ", " + this.infants_select + " " + infants_string;
        }
      }
      if (this.senior_select) {
        let senior_string = "";
        if (Number(this.senior_select) > 1) {
          senior_string = this.getrans("Seniors");
          results_subheadline +=
            ", " + this.senior_select + " " + senior_string;
        } else if (Number(this.senior_select) === 1) {
          senior_string = this.getrans("Senior");
          results_subheadline +=
            ", " + this.senior_select + " " + senior_string;
        }
      }
      console.info("results_subheadline", results_subheadline);
      /*         let combined_venue_name =
this.venue_select_name.trim() + " " + "Express Lane";
combined_venue_name = combined_venue_name.trim();
this.results_headline = this.getrans(combined_venue_name); */
      return results_subheadline;
    },

    set_results_quantitys() {
      const cpkChildrensSelect = sessionStorage.getItem("cpk_children_select");
      const cpkAdultsSelect = sessionStorage.getItem("cpk_adults_select");

      if (this.setbrandid == "BHX") {
        this.adults_select =
          Number(cpkChildrensSelect) + Number(cpkAdultsSelect);
      }
      if (this.date1_date && this.date1_time) {
        this.customers = [];
        let customers_array = [];
        let it = {};

        if (this.adults_select) {
          let adult_string = "";
          if (Number(this.adults_select) > 1) {
            adult_string = "Adults";
          } else if (Number(this.adults_select) === 1) {
            adult_string = "Adult";
          }

          if (
            Number(this.adults_select) +
              Number(this.children_select) +
              Number(this.infants_select) >
            this.booking_max_pax
          ) {
            this.adults_select =
              this.booking_max_pax -
              (Number(this.children_select) + Number(this.infants_select));
          }
          let adult_count =
            this.booking_max_pax -
            (Number(this.children_select) + Number(this.infants_select));
          it = {
            ctype: "ADL",
            count: Number(this.adults_select),
            display: adult_string,
            drop_count: adult_count,
          };
          customers_array.push(it);
        }
        // Component uses direct brand check - this is acceptable for components
        if (this.setbrandid == "HER" || this.setbrandid == "JER") {
          if (this.children_select) {
            let children_string = "";
            if (Number(this.children_select) > 1) {
              children_string = "Children";
            } else if (Number(this.children_select) === 1) {
              children_string = "Child";
            }

            if (
              Number(this.adults_select) +
                Number(this.children_select) +
                Number(this.infants_select) >
              this.booking_max_pax
            ) {
              this.children_select =
                this.booking_max_pax -
                (Number(this.adults_select) + Number(this.infants_select));
            }
            let adult_count =
              this.booking_max_pax -
              (Number(this.adults_select) + Number(this.infants_select));
            it = {
              ctype: "CHD",
              count: Number(this.children_select),
              display: children_string,
              drop_count: adult_count,
            };
            customers_array.push(it);
          }

          if (this.infants_select) {
            let infants_string = "";
            if (Number(this.infants_select) > 1) {
              infants_string = "Infants";
            } else if (Number(this.infants_select) === 1) {
              infants_string = "Infant";
            }

            if (
              Number(this.adults_select) +
                Number(this.children_select) +
                Number(this.infants_select) >
              this.booking_max_pax
            ) {
              this.infants_select =
                this.booking_max_pax -
                (Number(this.children_select) + Number(this.adults_select));
            }
            let adult_count =
              this.booking_max_pax -
              (Number(this.children_select) + Number(this.adults_select));
            it = {
              ctype: "INF",
              count: Number(this.infants_select),
              display: infants_string,
              drop_count: adult_count,
            };
            customers_array.push(it);
          }
        }
        setTimeout(() => {
          for (let z = 0; z < this.products.length; z++) {
            // Deep copy customers_array for each product row
            this.customers.push(JSON.parse(JSON.stringify(customers_array)));
            let price = parseFloat(this.products[z].ADL_rate || 0).toFixed(2);
            this.fasttracksubtotal_array[z] = price;
            this.check_zero_subtotal(z);
          }

          // After all customers are set, trigger set_sub_total for each product
          this.$nextTick(() => {
            for (let i = 0; i < this.customers.length; i++) {
              // Find the first ADL customer (or any, as needed)
              const custArr = this.customers[i];
              for (let j = 0; j < custArr.length; j++) {
                const cust = custArr[j];
                // Only trigger for visible selects (ADL/CHD/INF as needed)
                if (
                  cust.ctype === "ADL" ||
                  cust.ctype === "CHD" ||
                  cust.ctype === "INF"
                ) {
                  this.set_sub_total(`items-${i}`, `subtotal-${i}`, cust.ctype);
                }
              }
            }
          });
        }, 2000);
        console.info("this.customers 1", this.customers);
      }
    },
    async crosssellcheck() {
      //alert(1);
      let vis = [];
      let cvis = 0;
      let avis = 0;
      let ivis = 0;
      let adult_pax = 0;
      let child_pax = 0;
      let infant_pax = 0;
      for (let a = 0; a < this.visitortypes.length; a++) {
        let visitem = this.visitortypes[a];
        if (visitem.visitor_type_name == "Child") {
          cvis = visitem.visitor_type_id;
        }
        if (visitem.visitor_type_name == "Adult") {
          avis = visitem.visitor_type_id;
        }
        if (visitem.visitor_type_name == "Infant") {
          ivis = visitem.visitor_type_id;
        }
      }
      if (parseInt(this.adults_select) > 0) {
        let it = {};
        it.visitor_type_id = avis;
        it.count = this.adults_select;
        adult_pax = this.adults_select;
        vis.push(it);
      }
      if (parseInt(this.children_select) > 0) {
        let ita = {};
        ita.visitor_type_id = cvis;
        ita.count = this.children_select;
        child_pax = this.children_select;
        vis.push(ita);
      }
      if (parseInt(this.infants_select) > 0) {
        let iti = {};
        iti.visitor_type_id = ivis;
        iti.count = this.infants_select;
        infant_pax = this.children_select;
        vis.push(iti);
      }

      let datacsl = encryptStorage.getItem("datacsl");
      console.log('datacsl',datacsl);
      console.log('datacsl suggestions_data',this.suggestions_data);
      console.info("datacsl.venue_id", datacsl.venue_id);
      console.info("datacsl.venue_id", datacsl.venue_id);
      let fasttrack_arr = [];

      let lane_id_selected = this.lane_id_selected;
      let lane_type = "";
      console.info("lane_id_selected", lane_id_selected);

      for (let a = 0; a < this.suggestions_data.length; a++) {
        if (this.suggestions_data[a].ftt_suggested_id == lane_id_selected) {
          lane_type = this.suggestions_data[a].ftt_suggested_lane_type;
        }
      }
      let lane_object_not_to_change = {};
      for (let b = 0; b < datacsl.fasttrack.length; b++) {
        console.info("lane_type", lane_type);
        console.info("datacsl.fasttrack[b].lane_type", datacsl.fasttrack[b]);
        if (lane_type != datacsl.fasttrack[b].lane_type) {
          lane_object_not_to_change = datacsl.fasttrack[b];
        }
      }
      console.info("lane_type_selected", lane_type);
      console.info("lane_object_not_to_change", lane_object_not_to_change);
      for (let h = 0; h < this.suggestion_sub_product_id.length; h++) {
        if (
          this.suggestion_sub_product_id[h].toString() !=
          this.product_id_selected.toString()
        ) {
         // lane_object_not_to_change.product_id =
          //  this.suggestion_sub_product_id[h];
        }
      }
      if (lane_type == "outbound") {
        let outbound_ftt = {
          guid: this.genuuid(),
          //custom_search: "Y",
          venue_id: encryptStorage.getItem("fttvenues"),
          unit_data: { ADL: adult_pax, CHD: child_pax, INF: infant_pax },
         // product_id: this.product_id_selected,
          entry_date: this.date1_date,
          lane_type: "outbound",
          start_time: this.date1_time,
        };
        console.info("outbound_ftt", outbound_ftt);
        fasttrack_arr.push(outbound_ftt);
      }
      if (lane_type == "inbound") {
        let inbound_ftt = {
          guid: this.genuuid(),
         // custom_search: "Y",
          venue_id: encryptStorage.getItem("fttvenues"),
          unit_data: { ADL: adult_pax, CHD: child_pax, INF: infant_pax },
         // product_id: this.product_id_selected, 
          entry_date: this.date1_date,
          lane_type: "inbound",
          start_time: this.date1_time,
        };
        console.info("inbound_ftt", inbound_ftt);
        fasttrack_arr.push(inbound_ftt);
      }
      // lane_object_not_to_change.custom_search = "Y";
      lane_object_not_to_change.venue_id = encryptStorage.getItem("fttvenues");

      fasttrack_arr.push(lane_object_not_to_change);
      datacsl.fasttrack = fasttrack_arr;
      console.info("fasttrack_arr", fasttrack_arr);
      //encryptStorage.setItem("datacsl", datacsl);

      console.info("datacsl final", datacsl);

     const response = await apiProxy.call("cross_sell_availability", datacsl);
      if (response) {
        //Swal.close();

        this.expanded[0] = false;

        console.info("response", response);

        let datasent = response;
        let user_exists = datasent.user_exists;
        this.suggestions_data = [];
        if (user_exists == "N") {
          console.info('user_exists == "N"');
          this.noSlotsAvailable = true;
          this.loading_data_widget = false;
          this.finalloungeresults = [];
        }

        if (user_exists == "Y") {
         encryptStorage.setItem("crosssell_shown", "Yes");
         encryptStorage.setItem("crosssell_data", datasent);
         console.info("crosssell_data", datasent);
          encryptStorage.setItem("curr_search_results", this.searchres);
          window.location.reload();
          /*this.cross_sell_lounge_suggested = [];
          this.crosssell_data = datasent;
          if (this.crosssell_data.data) {
            this.crosssell_data.data.forEach((item) => {
              if (item.suggestion_product_id === "ftt") {
                console.info("itemftt", item);
                let additional_discount_applicable =
                  item.additional_discount_applicable;
                if (additional_discount_applicable == "Y") {
                  this.discount_type = item.discount_type;
                  this.discount_value = parseFloat(item.discount_value);
                }
                let lounge_id_suggested = item.api_data[0].lane_id;
                this.visitortypes =
                  item.api_data[0].calculations[0].visitor_types;
                this.cross_sell_lounge_suggested.push(lounge_id_suggested);
                this.final_amount = parseFloat(item.final_amount);
                let fttshown = {
                  product_id: "FTT",
                  amount: this.final_amount,
                  lane_name:
                    this.product_descriptions[item.suggestion_sub_product_id][
                      "product_title"
                    ],
                };
                console.info("crosssell_fttshown", fttshown);
                encryptStorage.setItem("crosssell_fttshown", fttshown);
                console.info("lounge_id_suggested", lounge_id_suggested);
                console.info("this.final_amount", this.final_amount);
                // this.date1_date = item.valid_from.replaceAll("-", "/");
                // this.date1_time = item.start_time;

                this.date1_forwidget = this.date1_date + " " + this.date1_time;
                let suggestion_item = {};
                suggestion_item.ftt_suggested_id = lounge_id_suggested;
                suggestion_item.ftt_suggested_date1_date =
                  item.valid_from.replaceAll("-", "/");
                suggestion_item.ftt_suggested_lane_type =
                  item.suggestion_sub_product_type;

                for (let t = 0; t < datacsl.fasttrack.length; t++) {
                  let ftt_sel = datacsl.fasttrack[t].lane_type;
                  if (item.suggestion_sub_product_type == ftt_sel) {
                    let unit_data = datacsl.fasttrack[t].unit_data;
                    suggestion_item.ADL = unit_data.ADL;
                    suggestion_item.CHD = unit_data.CHD;
                    suggestion_item.INF = unit_data.INF;
                    suggestion_item.ftt_suggested_date1_forwidget =
                      datacsl.fasttrack[t].entry_date +
                      " " +
                      datacsl.fasttrack[t].start_time;
                    suggestion_item.ftt_suggested_date1_time =
                      datacsl.fasttrack[t].start_time;
                  }
                }
                this.suggestions_data.push(suggestion_item);
                for (let a = 0; a < this.visitortypes.length; a++) {
                  let an = this.visitortypes[a];
                  if (an.system_visitor_type_name == "Adult") {
                    this.adults_select = an.count;
                  }
                  if (an.system_visitor_type_name == "Child") {
                    this.children_select = an.count;
                  }
                  if (an.system_visitor_type_name == "Infant") {
                    this.infants_select = an.count;
                  }
                }
                this.refresh_widget++;
              }
            });
            console.info(
              "this.cross_sell_lounge_suggested",
              this.cross_sell_lounge_suggested
            );
          }
          await this.getbranded();*/
        } else {
          //encryptStorage.setItem("crosssell_shown", "No");
          this.gotoPage("/yourdetails.html");
        }
      }
    },
    async getbranded() {
      try {
        const response = await apiProxy.call("brand_slug");
        if (response && response.code == "1") {
          this.setbrandid = response.slug;
          this.brandSlug = response.slug;
          this.currency = response.currency;

          const config = getBrandConfig(response.slug);
          if (config.currency) {
            this.currency = config.currency;
          }
          console.info("this.currency", this.currency);
          this.brandloaded = true;
          await this.loadTranslations();
          await this.getBrandData();
          await this.getcoachinitdetails();
          this.set_results_quantitys();
          if(this.cross_sell_ftt_outbound.length > 0)
          {
          await this.getApiData_fasttrack(this.cross_sell_ftt_outbound[0]);
          }
          if(this.cross_sell_ftt_inbound.length > 0)
          {
          await this.getApiData_fasttrack(this.cross_sell_ftt_inbound[0]);
          }
          this.sendFasttrackViewItemListToDataLayer();
          this.brandloaded = true;
          this.widgetloaded = true;



        }
      } catch (error) {
        console.error("ERROR in getbranded:", error);
      }
    },

    async getcoachinitdetails() {
      try {
        console.log('🚌 getcoachinitdetails() started');
        let data = { brand_id: this.setbrandid };
        console.log('📡 Calling fasttrack_init API with data:', data);

        const response = await apiProxy.call('fasttrack_init', data);
        console.log('🚌 fasttrack_init API response:', response);
        
        if (response && response.code == 1 && response.status === 'success' && response.data) {
          console.log("✅ fasttrack_init details success:", response.data);

          const laneRules = response.data.widget_config.lane_rules || [];
          const maxUnitRule = laneRules.find(
            (laneRule) => laneRule.code === "max_unit_per_booking"
          );
          const configuredMaxPax = Number(maxUnitRule?.value);
          if (configuredMaxPax > 0) {
            this.booking_max_pax = configuredMaxPax;
          }



          console.log("fasttrack_init this.booking_max_pax", this.booking_max_pax);

        } else {
          console.error('❌ Fasttrack init API failed:', response);
        }
      } catch (error) {
        console.error('💥 Error in getcoachinitdetails:', error);
      }
    },
    set_fttcrossell_shown() {
      this.crosssell_data.data.forEach((item) => {
        console.info("item cross", item);
        if (item.suggestion_product_id === "ftt") {
          console.info("product_descriptions", this.product_descriptions);
          this.final_amount = parseFloat(item.final_amount);
          let fttshown = {
            product_id: "FTT",
            amount: this.final_amount,
            lane_name:
              this.product_descriptions[item.suggestion_sub_product_id][
                "product_title"
              ],
          };
          console.info("crosssell_fttshown", fttshown);
          encryptStorage.setItem("crosssell_fttshown", fttshown);
        }
      });
    },
  },
  created() {},
  mounted() {
    console.info("🔥 CrossSellResultsFTT MOUNTED - Component is loading");
    console.info("🔥 Props received:", {
      crosssell_data_passed: this.crosssell_data_passed,
      num_of_crosssells: this.num_of_crosssells,
    });

    // Use passed crosssell data instead of storage
    this.crosssell_data =
      this.crosssell_data_passed || encryptStorage.getItem("crosssell_data");

    console.info("🔥 Using crosssell_data:", this.crosssell_data);
    if (this.crosssell_data && this.crosssell_data.data) {
      console.info("🔥 crosssell_data.data:", this.crosssell_data.data);
    } else {
      console.info("🔥 ERROR: No crosssell_data.data found!");
      this.noSlotsAvailable = true;
      return;
    }
    this.cross_sell_lounge_suggested = [];
    console.info(
      "🔥 About to process crosssell_data.data:",
      this.crosssell_data.data
    );
    if (this.crosssell_data.data) {
      console.info(
        "🔥 Processing",
        this.crosssell_data.data.length,
        "crosssell items"
      );
      this.crosssell_data.data.forEach((item, index) => {
        console.info("🔥 Processing item", index, ":", item);
        if (item.suggestion_product_id === "lng") {
          this.package_id_selected =
            item.api_data[0].calculations[0].package_id;
        }
        if (item.suggestion_product_id === "ftt" && item.status == "success") {
          console.info("🔥 FOUND FTT ITEM!", item);
          this.discount_value = parseFloat(item.discount_value);
          this.venue_select = String(item.sub_venue_id);
          let lounge_id_suggested = item.api_data[0].lane_id;
          this.lane_id_selected = String(item.api_data[0].lane_id);
          this.visitortypes = item.api_data[0].calculations[0].visitor_types;

          this.cross_sell_lounge_suggested.push(lounge_id_suggested);
          this.suggestion_sub_product_id.push(item.suggestion_sub_product_id);
          this.final_amount = parseFloat(item.final_amount);
          console.info("fasttrack_id_suggested", lounge_id_suggested);
          console.info("this.final_amount", this.final_amount);
          console.info("this.product_descriptions", this.product_descriptions);

          let date_formatted = item.valid_from.replaceAll("-", "/");
          if(item.suggestion_sub_product_type=="outbound")
          {
            this.cross_sell_ftt_outbound = [];
            this.cross_sell_ftt_outbound.push({lane_id: String(lounge_id_suggested), date: date_formatted, time: item.start_time, suggestion_sub_product_id:item.suggestion_sub_product_id});
          }
          if(item.suggestion_sub_product_type=="inbound")
          {
            this.cross_sell_ftt_inbound = [];
            this.cross_sell_ftt_inbound.push({lane_id: String(lounge_id_suggested), date: date_formatted, time: item.start_time, suggestion_sub_product_id:item.suggestion_sub_product_id});
          }          

          let datacsl = encryptStorage.getItem("datacsl");
          this.date1_date = item.valid_from.replaceAll("-", "/");
          this.date1_time = datacsl ? datacsl.start_time : "15:00";

          this.date1_forwidget = this.date1_date + " " + this.date1_time;
          let suggestion_item = {};
          suggestion_item.ftt_suggested_id = lounge_id_suggested;
          suggestion_item.ftt_suggested_date1_date = item.valid_from.replaceAll("-","/");
          suggestion_item.ftt_suggested_date1_time = item.start_time;

          suggestion_item.ftt_suggested_lane_type = item.suggestion_sub_product_type;
          suggestion_item.ftt_suggested_date1_forwidget = item.valid_from.replaceAll("-","/") + " " + item.start_time;

          if (datacsl && datacsl.fasttrack) {
            for (let t = 0; t < datacsl.fasttrack.length; t++) {
              let ftt_sel = datacsl.fasttrack[t].lane_type;
              if (item.suggestion_sub_product_type == ftt_sel) {
                let unit_data = datacsl.fasttrack[t].unit_data;
                suggestion_item.ADL = unit_data.ADL;
                suggestion_item.CHD = unit_data.CHD;
                suggestion_item.INF = unit_data.INF;
                /* suggestion_item.ftt_suggested_date1_forwidget =
                  datacsl.fasttrack[t].entry_date +
                  " " +
                  datacsl.fasttrack[t].start_time;
                suggestion_item.ftt_suggested_date1_time =
                  datacsl.fasttrack[t].start_time;
                  */
              }
            }
          }
          this.suggestions_data.push(suggestion_item);
          this.refresh_widget++;
        }
      });
      //suggestions_data
      console.info(
        "this.cross_sell_lounge_suggested",
        this.cross_sell_lounge_suggested
      );
      console.info("this.suggestions_data", this.suggestions_data);
      console.info(
        "this.suggestion_sub_product_id",
        this.suggestion_sub_product_id
      );
    }

    //  this.date1_forwidget =
    //     this.correctdate(urlParams.get("date1_date")) +
    //     " " +
    //     urlParams.get("date1_time");
    //   this.date2_forwidget =
    //     this.correctdate(urlParams.get("date2_date")) +
    //     " " +
    //     urlParams.get("date2_time");

    //this.getbranded();

    // this.setLocalData("venue_selected", "5");
    console.info("this.date1_date", this.date1_date);
    console.info("this.date1_time", this.correctdate(this.date1_date));

    console.info("this.date1_date", this.date1_date);
    console.info("this.date1_time", this.date1_time);
    console.info("this.date2_date", this.date2_date);
    console.info("this.date2_time", this.date2_time);
    //"11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am";

    this.actcustomers["ADL"] = Number(this.adults_select);
    this.actcustomers["CHD"] = Number(this.children_select);
    this.actcustomers["INF"] = Number(this.infants_select);

    this.actcustomerprices["ADL"] = 0;
    this.actcustomerprices["CHD"] = 0;
    this.actcustomerprices["INF"] = 0;
    setTimeout(() => {
      //this.widgetloaded = true;
      //this.getBrandData();
      //sessionStorage.clear();
    }, 0);

    console.info("this.venue_select");
    console.info(this.venue_select);

    // setTimeout(() => {
    //   this.set_sub_total("items-0", "subtotal-0", "ADL");
    //   this.set_sub_total("items-0", "subtotal-0", "CHD");
    //   this.set_sub_total("items-0", "subtotal-0", "INF");
    //   this.check_zero_subtotal("0");
    // }, 3000);

    window.addEventListener(
      "search-emit",
      (event) => {
        console.info("got search-emit event", event.detail.data);

        if (event.detail.data.tab !== "Fasttrack") {
          return false;
        }

        if (this.noSlotsAvailable) {
          this.noSlotsAvailable = false;
          this.dataloaded = false;
        }

        this.manual_search = true;
        this.loading_data_widget = true;
        // // this.getbranded();
        // console.info("event emit", JSON.stringify(event));
        this.date1_date = this.formatDateymd(event.detail.data.date1);
        this.date1_time = `${event.detail.data.date1_time}`;

        // // this.date2_date = event.detail.data.date2_date;
        // // this.date2_time = event.detail.data.date2_time;
        this.adults_select = `${event.detail.data.adults_select}` || ``;
        this.children_select = `${event.detail.data.children_select}` || ``;

        if (this.infants_select) {
          this.infants_select = `${event.detail.data.infants_select}` || ``;
        }

        this.senior_select = `${event.detail.data.senior_select}` || ``;

        this.venue_select = `${event.detail.data.venue_select}`;
        this.venue_name = `${event.detail.data.venue_select_name}`;

        this.search_origin = `${event.detail.data.search_origin}`;
        this.lane_id_selected = `${event.detail.data.crossell_lane_select}`;

        // //this.setLocalData("venue_selected", this.venue_select);

        console.info("this.date1_date, this.date1", this.date1_date);

        this.crosssellcheck();
      },
      false
    );

    const datacsl = encryptStorage.getItem("datacsl");
    this.venue_select_name = datacsl ? datacsl.venue_select_name : "";
    console.info("🔥 About to call getbranded() in 200ms");
    setTimeout(async () => {
      console.info("🔥 Calling getbranded() now"); 
      await this.getbranded();
      encryptStorage.setItem("crosssell_shown", "Yes");
      //this.getBrandData();
      //sessionStorage.clear();
    }, 200);

    // setTimeout(() => {
    //   this.children_select = "2";
    //   this.getbranded();
    // }, 5000);
  },

  updated() {},
};
</script>

<style lang="scss">
.results_expanded_description ul {
  padding: 1rem;
  margin: 0;
  li {
    margin-bottom: 0.5rem;
  }
}
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.results-fade.not-loaded {
  opacity: 0;
}

.results-fade {
  overflow: hidden;
  opacity: 1;
  transition: opacity 1s ease;
}

.results {
  max-width: calc(1280px + 2rem);
  // padding: 0 1rem;
  // margin: 3rem auto;
  background: #fff;

  &-container {
    margin-top: 3.75rem;
    @media screen and (max-width: 768px) {
      margin-top: 1rem;
    }
  }

  &_box {
    max-width: 1280px;
    margin: 0 auto 1rem;
    @media screen and (max-width: 767px) {
      margin: 0 auto 1rem;
    }
    width: 100%;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #dfdfdf;
  }
  &_top {
    display: flex;
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
    &_image_title_description {
      width: 100%;
      display: flex;
    }
    &_image {
      flex: 0;
      align-self: flex-start;
      max-width: 175px;
      @media screen and (max-width: 959px) {
        width: 180px;
      }
      @media screen and (max-width: 767px) {
        width: 33%;
        display: none;
      }
      height: auto;
      background: #ddd;
    }
    &_title_description {
      width: 100%;
      padding: 1.5rem;
      @media screen and (max-width: 959px) {
        padding: 1rem;
      }
    }
    &_title {
      font-size: 1.25rem;
      color: #1a2a40;
    }
    &_description {
      font-size: 1rem;
      color: #707070;
    }
    &_price_button {
      width: auto;
    }
    &_price_button {
      display: flex;
      flex-direction: column;
      @media screen and (max-width: 767px) {
        flex-direction: row;
      }
      justify-content: space-between;
      align-items: center;
      min-width: 175px;
      border-left: 1px solid #ddd;

      del {
        font-size: 1.2rem;
        color: #999;
        display: inline-block;
        padding-right: 0.5rem;
      }

      .notes {
        font-size: 1.2rem;
        color: #999;
        display: block;
        font-size: 1rem;
      }
    }
    &_price {
      padding: 1rem 1rem;
      flex: 1;
      display: flex;
      justify-content: center;

      @media screen and (min-width: 767.98px) {
        > div {
          display: flex;
          flex-direction: column;
        }
      }

      @media screen and (max-width: 767px) {
        justify-content: flex-start;
        padding: 0rem 1rem;
        align-items: baseline;
      }
      align-items: center;
      color: #707070;
      font-size: 1.25rem;
      text-align: center;
      b {
        font-size: 1.75rem;
        color: #1a2a40;
      }
      @media screen and (max-width: 767px) {
        justify-content: center;
        align-items: baseline;
        padding: 0rem 1rem;
        font-size: 1rem;
        b {
          font-size: 1.3rem;
          color: #1a2a40;
        }
      }
    }
    &_button {
      flex: 0;
      @media screen and (max-width: 767px) {
        flex: 1;
      }
      width: 100%;
      button {
        padding: 1.25rem 1rem;
        @media screen and (max-width: 959px) {
          padding: 1rem 1rem;
          font-size: 1rem;
        }
        width: 100%;
        background-color: var(--result_button_expand_background, #034a94);
        color: var(--result_button_expand_font_color, #ffffff);
        border: none;
        font-size: var(--result_button_expand_font_size, 1.325rem);
        font-weight: var(--result_button_expand_font_weight, bold);
        font-family: var(--result_button_expand_font_family, inherit);
      }
      button:disabled {
        filter: saturate(0);
        cursor: not-allowed;
      }
    }
  }
}

.results_expanded {
  &_wrapper {
    display: flex;
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
    border-top: 1px solid #dfdfdf;
  }
  &_title_description {
    width: 100%;
    padding: 1.5rem;
    @media screen and (max-width: 959px) {
      padding: 1rem;
    }
    @media screen and (max-width: 767px) {
      padding: 1rem;
      padding-bottom: 0rem;
    }
    p {
      margin-bottom: 0;
    }
  }
  &_title {
    font-size: 1.25rem;
    color: #1a2a40;
  }
  &_description {
    font-size: 1rem;
    color: #707070;
  }
  &_price_quantity {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    @media screen and (max-width: 767px) {
      flex-direction: row-reverse;
      border-left: 0px solid #ddd;
    }
    justify-content: space-between;
    align-items: center;
    min-width: 275px;
    border-left: 1px solid #ddd;
  }
  &_price {
    padding: 1rem 1rem;
    @media screen and (max-width: 767px) {
      padding: 0rem 1rem;
    }
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    @media screen and (max-width: 767px) {
      justify-content: flex-end;
    }
    color: #707070;
    font-size: 1rem;
    b {
      font-size: 1.25rem;
      color: #1a2a40;
    }
  }
  &_quantity {
    padding: 1rem 1rem 1rem;
    flex: 1;
    @media screen and (max-width: 959px) {
      padding: 1rem;
      flex: 0;
    }
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > div:nth-child(odd) {
    background: #f5f5f5;
  }
}

.results_add {
  box-sizing: border-box;
  display: flex;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
  align-items: center;
  border-top: 1px solid #dfdfdf;
  &_subtotal {
    padding: 0rem 2rem;
    @media screen and (max-width: 959px) {
      padding: 0rem 1rem;
    }
    @media screen and (max-width: 767px) {
      padding: 1rem;
    }
    flex: 1;
    align-items: baseline;
    color: #1a2a40;
    font-size: 1.25rem;
    b {
      font-size: 1.75rem;
      color: #2370a1;
    }
  }
  &_button {
    flex: 0;
    @media screen and (max-width: 767px) {
      flex: 1;
      width: 100%;
    }
    min-width: 275px;
    button {
      padding: 1.25rem 1rem;
      @media screen and (max-width: 959px) {
        padding: 1rem 1rem;
        font-size: 1rem;
      }
      width: 100%;
      background-color: var(--result_button_primary_background, #034a94);
      color: var(--result_button_primary_font_color, #fff);
      border: none;
      font-size: 1.325rem;
      font-weight: bold;
    }
    button:disabled {
      filter: saturate(0);
      cursor: not-allowed;
    }
  }
}

.quantity-selector {
  display: flex;
  button {
    padding: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background: #dfdfdf;
    color: #1a2a40;
  }
  select {
    border: 1px solid #dfdfdf;
    padding: 0.75rem;
    cursor: pointer;
  }
}

.date_search {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;
}

.loading-results {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 1.275rem;
  color: #555;
  padding: 3rem 1rem;
  max-width: 1280px;
  margin: 0 auto 3rem;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #dfdfdf;
  background: #fff;
  .search-widget {
    width: 100%;
  }
}

.search-dates {
  color: var(--basket_price_font_color, #236ca3);
}

.edit-search {
  background: #e9e7e7;
  box-shadow: 0 2px 2px 0 #0000002e;
  border: 0px;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  font-weight: bold;
  color: #236ca3;
}

.datetime-message {
  font-size: 0.9rem;
  padding: 0.75rem 1rem;
  text-align: center;
  width: 100%;
  background: #f5f5f5;
  border-top: 1px solid #dfdfdf;
}
</style>


